import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
import NProgress from '@/utils/nprogress'

Vue.use(Router)

const router =  new Router({
  mode:'hash',
  routes: [
    {
      path:'/login',
      mane:'login',
      component:()=>import("../pages/login/index")
    },
    {
      path: '/',
      name: 'layout',
      redirect:'/gift',
      component: ()=>import("../pages/layout/index"),
      children:[
        {
          path:'/gift',
          name:'orchard',
          meta:{
            title:'礼品管理',
            lv:1
          },
          icon:'el-icon-present',
          component:()=>import("../pages/gift/index")
        },
        {
          path:'/gift/add',
          name:'addorchard',
          meta:{
            title:'新增礼品',
            lv:2
          },
          component:()=>import("../pages/gift/add")
        },
        {
          path:'/gift/edit',
          name:'editorchard',
          meta:{
            title:'编辑礼品',
            lv:2
          },
          component:()=>import("../pages/gift/add")
        },
        {
          path:'/order',
          name:'order',
          meta:{
            title:'订单管理',
            lv:1
          },
          icon:'el-icon-document',
          component:()=>import("../pages/order/index")
        },
        {
          path:'/order/details',
          name:'orderdetails',
          meta:{
            title:'订单详情',
            lv:2
          },
          component:()=>import("../pages/order/details")
        },    
        {
          path:'/record',
          name:'record',
          meta:{
            title:'出库记录',
            lv:1
          },
          icon:'el-icon-notebook-2',
          component:()=>import("../pages/record/index")
        },
        {
          path:'/skuInLog',
          name:'skuInLog',
          meta:{
            title:'入库记录',
            lv:1
          },
          icon:'el-icon-coin',
          component:()=>import("../pages/skuInLog/index")
        },
        {
          path:'/primaryProducts',
          name:'primaryProducts',
          meta:{
            title:'初级产品管理',
            lv:1
          },
          icon:'el-icon-goods',
          component:()=>import("../pages/primaryProducts/index")
        },
        {
          path:'/primaryProducts/add',
          name:'addprimaryProducts',
          meta:{
            title:'新增初级产品',
            lv:2
          },
          component:()=>import("../pages/primaryProducts/add")
        },
        {
          path:'/primaryProducts/edit',
          name:'editprimaryProducts',
          meta:{
            title:'编辑初级产品',
            lv:2
          },
          component:()=>import("../pages/primaryProducts/add")
        },
        {
          path:'/ppRecord',
          name:'ppRecord',
          meta:{
            title:'初级产品出库记录',
            lv:1
          },
          icon:'el-icon-notebook-2',
          component:()=>import("../pages/ppRecord/index")
        },
        {
          path:'/ppSkuInLog',
          name:'ppSkuInLog',
          meta:{
            title:'初级产品入库记录',
            lv:1
          },
          icon:'el-icon-coin',
          component:()=>import("../pages/ppSkuInLog/index")
        },
        {
          path:'/user',
          name:'user',
          meta:{
            title:'用户管理',
            lv:1
          },
          icon:'el-icon-user',
          component:()=>import("../pages/user/index")
        }
      ]
    }
  ]
})

router.beforeEach((to,from,next)=>{
  NProgress.start()
  if(to.meta.lv==1){
    store.commit('changePage',to.path)
  }
  next()
})

router.afterEach(()=>{
  NProgress.done()
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js